// Thư mục: src/stores/khoDonHangStore.js
import { defineStore } from "pinia";
import { DonHangApi } from "@/services/donHangService";
import nguoiDungAPi from "@/services/userService";

export const useKhoDonHangStore = defineStore("khoDonHang", {
  state: () => ({
    isLoadingList: false,
    listError: null,
    items: [],
    page: 0,
    size: 10,
    sort: "ngayTao,asc",
    totalPages: 1,
    totalElements: 0,
    filterTrangThai: "CHO_HOACH_DINH",

    isLoadingDetail: false,
    detailError: null,
    currentOrder: null,

    // --- BỔ SUNG: OPTIONS CHO DROPDOWN ---
    isLoadingOptions: false,
    khoNhanVienOptions: [], // Danh sách Nhân viên Kho
  }),
  getters: {
    currentPage(state) {
      return state.page + 1;
    },
  },
  actions: {
    async fetchList() {
      this.isLoadingList = true;
      this.listError = null;
      try {
        const params = {
          page: this.page,
          size: this.size,
          sort: this.sort,
          trangThai: this.filterTrangThai,
        };
        // Gọi API listKho (hoặc listAll nếu Backend dùng chung)
        const data = await DonHangApi.listKho(params);
        this.items = data.content || [];
        this.totalPages = data.totalPages ?? 1;
        this.totalElements = data.totalElements ?? this.items.length;
        this.page = data.number ?? 0;
      } catch (e) {
        this.listError = e?.response?.data?.message || "Lỗi tải danh sách";
      } finally {
        this.isLoadingList = false;
      }
    },
    async setFilterTrangThai(status) {
      this.filterTrangThai = status;
      this.page = 0;
      await this.fetchList();
    },
    setPage(p1) {
      this.page = Math.max(0, p1 - 1);
      this.fetchList();
    },

    async openDetailModal(orderId) {
      this.isLoadingDetail = true;
      this.detailError = null;
      try {
        // Tải chi tiết đơn VÀ tải danh sách NV Kho
        const [orderData] = await Promise.all([
          DonHangApi.getById(orderId),
          this.fetchKhoOptionsIfNeeded(), // Gọi hàm tải options
        ]);
        this.currentOrder = orderData;
      } catch (e) {
        this.detailError = e?.response?.data?.message || "Lỗi tải chi tiết";
      } finally {
        this.isLoadingDetail = false;
      }
    },
    clearDetailModal() {
      this.currentOrder = null;
      this.detailError = null;
    },

    async fetchKhoOptionsIfNeeded() {
      if (this.khoNhanVienOptions.length > 0) return; // Chỉ tải 1 lần
      this.isLoadingOptions = true;
      try {
        // (Giả sử API này trả về List<NguoiDungResponse> thuộc chức vụ KHO_PICKER)
        const res = await nguoiDungAPi.getUsersChucVuCode("NV_KHO");
        const data = res.data;
        console.log("Check kho: ", data);
        this.khoNhanVienOptions = data || [];
      } catch (e) {
        console.error("Lỗi tải danh sách Nhân viên Kho:", e);
        this.detailError = "Lỗi tải danh sách Nhân viên Kho";
      } finally {
        this.isLoadingOptions = false;
      }
    },

    // --- Actions của Kho ---
    async baoThieuHang(orderId, ghiChuKho) {
      this.isLoadingDetail = true;
      this.detailError = null;
      try {
        // (Backend phải lấy khoId từ Token)
        await DonHangApi.khoBaoThieu(orderId, ghiChuKho);
        await this.fetchList();
      } catch (e) {
        this.detailError = e?.response?.data?.message || "Lỗi báo thiếu hàng";
        throw e;
      } finally {
        this.isLoadingDetail = false;
      }
    },
    async hoachDinhVaChuanBi(orderId, payload) {
      // payload: { diemDungList: [...] }
      this.isLoadingDetail = true;
      this.detailError = null;
      try {
        // (Backend phải lấy khoId từ Token)
        await DonHangApi.khoHoachDinh(orderId, payload);
        await this.openDetailModal(orderId); // Tải lại chi tiết (để sang bước 2)
      } catch (e) {
        this.detailError = e?.response?.data?.message || "Lỗi hoạch định";
        throw e;
      } finally {
        this.isLoadingDetail = false;
      }
    },
    async sanSangGiao(orderId, payload) {
      // payload: { phieuXuatKhoUrl: "..." }
      this.isLoadingDetail = true;
      this.detailError = null;
      try {
        // (Backend phải lấy khoId từ Token)
        await DonHangApi.khoSanSangGiao(orderId, payload);
        await this.fetchList();
      } catch (e) {
        this.detailError = e?.response?.data?.message || "Lỗi báo sẵn sàng";
        throw e;
      } finally {
        this.isLoadingDetail = false;
      }
    },
  },
});
